import { ApiRequestConfig, api } from '@comall-backend-builder/core/lib/services/api';
import { getStore } from '@comall-backend-builder/core/lib/store';
import { actions } from '@comall-backend-builder/core';
export const SaleOrderPayingListSknsLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        console.log(params, 'params')
        config.apiPath = `/changePrice/orderSkn/${params.order_id}`;
        return api.get(config);
    },
};
export const SaleOrderPayingListLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = `/changePrice/orderList`;
        return api.get(params, config).then((res: any) => {
            const result = res || []
            const resData = result.map((item: any) => ({
                id: item.id,
                name: item.orderNo
            }))
            return resData
        });
    },
};
export const SaleOrderChangePriceDetailLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/changePrice/detail';
        return api.get(params, config).then((res: any) => {
            return {
                ...res.main
            }
        });
    },
};
export const SaleOrderChangePriceDetailSknLoader = {
    get: async function(params: any, config: ApiRequestConfig) {
        config.apiPath = '/changePrice/detail';
        return api.get(params, config).then((res: any) => {
            return res.item
        });
    },
};


